import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { Suspense } from "react";
import { z } from "zod";
import { PROJECT } from "@/app/capabilities/permissions";
import { toolkitCollectionQueryOptions } from "@/app/tools/api/get-toolkit-collection";
import { ToolsListSkeleton } from "@/app/tools/components/tools-list-skeleton";
import { ToolsList } from "@/app/tools/list";
import { RouteErrorBoundary } from "@/components/custom/router/route-error-boundary";
import { requireProjectPermission } from "@/lib/route-guards";

const toolsSearchSchema = z.object({
  search: fallback(z.string(), "").default(""),
  toolkits: fallback(z.array(z.string()), []).default([]),
  authProviders: fallback(z.array(z.string()), []).default([]),
  secrets: fallback(z.array(z.string()), []).default([]),
});

const defaultValues = {
  search: "",
  // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
  toolkits: [] as string[],
  // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
  authProviders: [] as string[],
  // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
  secrets: [] as string[],
};

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/tools"
)({
  validateSearch: zodValidator(toolsSearchSchema),
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
  errorComponent: RouteErrorBoundary,
  component: () => (
    <Suspense fallback={<ToolsListSkeleton />}>
      <ToolsList />
    </Suspense>
  ),
  beforeLoad: async (ctx) => {
    await requireProjectPermission(ctx, PROJECT.tools.read);
    ctx.context.queryClient.prefetchQuery(
      toolkitCollectionQueryOptions(ctx.params)
    );
  },
  loader: () => ({
    crumb: "Tool Catalog",
  }),
});
